import { reduxForm } from 'redux-form';
import { createUsers } from '../../actions/users_actions';

import UserForm from '../../components/Users/userForm'

function validate(values) {
    const errors = {};
    if (!values.name) {
        errors.name = 'Enter a username';
    }
    if (!values.email) {
        errors.email = 'Enter a category';
    }

    if (!values.phone) {
        errors.phone = 'Enter some phone';
    }
    return errors;
}

function mapStateToProps(state) {
    return {
        user: state.users.currentUser
    };
}

export default reduxForm({
    form: 'userForm',
    fields: ['name', 'email', 'phone', 'address.city', 'address.street'],
    validate
}, mapStateToProps, { createUsers })(UserForm);


// WEBPACK FOOTER //
// ./master/jsx/containers/Users/userForm.js